import { useEffect, useState } from 'react';
import { cn } from '@/lib/cn.ts';

export function Countdown({ expiresAt, large = false }: { expiresAt: string | null; large?: boolean }) {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (!expiresAt) return null;
  const remaining = Math.max(0, Math.floor((new Date(expiresAt).getTime() - now) / 1000));
  const mm = Math.floor(remaining / 60)
    .toString()
    .padStart(2, '0');
  const ss = (remaining % 60).toString().padStart(2, '0');

  const danger = remaining <= 60;
  const warn = remaining <= 180;

  return (
    <div
      aria-live="polite"
      className={cn(
        'mono tnum transition-colors',
        large ? 'text-3xl font-light tracking-tight' : 'text-[12px] tracking-wider',
        danger ? 'text-accent' : warn ? 'text-gold' : 'text-text-muted',
      )}
    >
      {mm}
      <span className={cn('opacity-50', danger && 'animate-pulse')}>:</span>
      {ss}
    </div>
  );
}
